import {
    Coffee,
    SchoolRounded,
    DataObjectRounded,
    DomainVerificationRounded,
} from "@mui/icons-material";

import userAvatar from "../assets/user.png";

export const devWorkInfo = [
    {
        tooltipTitle: "تعداد قهوه های خورده شده",
        icon: <Coffee />,
        total: 1650,
        color: "lightcoral",
    },
    {
        tooltipTitle: "تعداد دوره های من",
        icon: <SchoolRounded />,
        total: 25,
        color: "lightskyblue",
    },
    {
        tooltipTitle: "تعداد پروژه های من",
        icon: <DataObjectRounded />,
        total: 34,
        color: "lightslategray",
    },
    {
        tooltipTitle: "تعداد پروژه های به پایان رسیده",
        icon: <DomainVerificationRounded />,
        total: 12,
        color: "lightseagreen",
    },
];

export const devEdu = [
    {
        year: "١٣٦٩- ١٣٦٥ ",
        cert: "دیپلم",
        major: "رشته ریاضی و فیزیک" ,
        place: " دبیرستان دکتر بهشتی  رشت",
    },
    {
        year: "١٣٧٢- ١٣٧٧ ",
        cert: "کارشناسی",
        major: "رشته ریاضیات کاربرد",
        place: "دانشگاه دولتی  بیرجند",
    },
    {
        year: "١٣٩٤- ١٣٩٢ ",
        cert: "کارشناسی ارشد",
        major: "رشته کامپیوتر گرایش نرم افزار",
        place: "دانشگاه آزاد اسلامی واحد قزوین",
    },
];

export const devExper = [
    {
        year: "١٣٩٨- ١٣٩١",
        cert: "سازمان مالیاتی کشور",
        major: "مدیر فناوری اطلاعات " ,
        place: "اداره کل امور مالیاتی گیلان",
    },
    {
        year: " ١٣٩١ تا امروز",
        cert: "سازمان مالیاتی کشور",
        major: "کارشناس مسول نرم افزار" ,
        place: "اداره کل امور مالیاتی گیلان",
    },
    {
        year: "١٣٩٩- ١٣٨٤ ",
        cert: "شرکت تلاش  گیلان",
        major: "مدیریت و اجرای برنامه نویسی",
        place: "پروژه مطب پزشکی تلاش",
    },
];

export const userComments = [
    {
        fullname: " حسن نظرپرور نوشادی",
        jobTitle: "مدرس و برنامه نویس فول استک",
        avatar: userAvatar,
        comment: `
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه
              `,
    },
    {
        fullname: " حسن نظرپرور نوشادی",
        jobTitle: "مدرس و برنامه نویس فول استک",
        avatar: userAvatar,
        comment: `
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه
              `,
    },
    {
        fullname: " حسن نظرپرور نوشادی",
        jobTitle: "مدرس و برنامه نویس فول استک",
        avatar: userAvatar,
        comment: `
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه
              `,
    },
    {
        fullname: " حسن نظرپرور نوشادی",
        jobTitle: "مدرس و برنامه نویس فول استک",
        avatar: userAvatar,
        comment: `
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه
              `,
    },
    {
        fullname: " حسن نظرپرور نوشادی",
        jobTitle: "مدرس و برنامه نویس فول استک",
        avatar: userAvatar,
        comment: `
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه
              `,
    },
    {
        fullname: " حسن نظرپرور نوشادی",
        jobTitle: "مدرس و برنامه نویس فول استک",
        avatar: userAvatar,
        comment: `
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه
              `,
    },
];
